import gql from 'graphql-tag'

export const SERVICE_ACTIONS = gql`
  query ServiceActions($filter: ServiceActionsFilter) {
    serviceActions(filter: $filter) {
      isSuccessful
      message
      serviceActions {
        data {
          action
          companyId
          serviceActionId
        }
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
      }
    }
  }
`

export const CREATE_SERVICE_ACTIONS = gql`
  mutation CreateServiceAction($input: CreateServiceActionInput!) {
    createServiceAction(input: $input) {
      isSuccessful
      message
      createServiceAction {
        serviceActionId
        action
      }
    }
  }
`

export const UPDATE_SERVICE_ACTIONS = gql`
  mutation UpdateServiceAction($input: UpdateServiceActionInput!) {
    updateServiceAction(input: $input) {
      isSuccessful
      message
      updateServiceAction {
        action
        serviceActionId
      }
    }
  }
`

export const DELETE_SERVICE_ACTIONS = gql`
  mutation DeleteServiceAction($input: DeleteServiceActionInput!) {
    deleteServiceAction(input: $input) {
      isSuccessful
      message
      deleteServiceAction {
        serviceActionId
        action
      }
    }
  }
`
